export const rulesExportFileHeaders = ['name', 'description', 'library', 'documentClass', 'labels', 'category', 'categoryValue'];
export const rulesKeys = ['name', 'description', 'library', 'documentType', 'labels', 'category', 'categoryValue'];
